import { Modal } from '@/components/molecules/Modal/Modal'
import { useGlobalModalStore } from '@/stores/useGlobalModalStore/useGlobalModalStore'

export const GlobalModal = () => {
    const { setModalState: _setModalState, ...restProps } =
        useGlobalModalStore()

    return <Modal {...restProps} />
}
